import { atomWithStorage } from "jotai/utils";

import { ZitadelOrg } from "~/utils/Types";

const initialValue = undefined;

export const zitadelOrgAtom = atomWithStorage<ZitadelOrg | undefined>(
  "zitadelOrg",
  initialValue,
  undefined,
  { getOnInit: true },
);
